export default "__VITE_ASSET__CjIt0fzB__"